import { useAuth0 } from "@auth0/auth0-react";
import { useMemo } from "react";
import { capturePreAuth0LandingUrl } from "./landingUrl";

/**
 * Drop-in replacement for useAuth0 when calling loginWithRedirect / loginWithPopup
 * so pre-Auth0 landing URL is captured before leaving the donate app.
 */
export const useAuth0Login = () => {
  const auth0 = useAuth0();

  return useMemo(
    () => ({
      ...auth0,
      loginWithRedirect: (
        options?: Parameters<typeof auth0.loginWithRedirect>[0]
      ) => {
        capturePreAuth0LandingUrl();
        return auth0.loginWithRedirect(options);
      },
      loginWithPopup: (options?: Parameters<typeof auth0.loginWithPopup>[0]) => {
        capturePreAuth0LandingUrl();
        return auth0.loginWithPopup(options);
      },
    }),
    [auth0]
  );
};
